<template>
  <el-dialog :modal="true" :modal-append-to-body="true" append-to-body :title="dialogObj.title" :width="dialogObj.width"
    :height="dialogObj.height" :close-on-click-modal="false" :before-close="handleDialogClose" :show-close="dialogObj.showclose"
    :visible.sync="dialogObj.isShow" v-if="dialogObj.isShow" :close-on-press-escape="true"
    :fullscreen="dialogObj.fullscreen" :center="dialogObj.center">
    <slot></slot>
    <div class="dialog-footer" v-if="dialogObj.events!='' && dialogObj.events != undefined && dialogObj.btn!=false">
      <el-button size="mini" v-for="(item,index) in dialogObj.events" :key="index" :type="item.type" :plain="item.plain"
        @click="btnEvent(item.action)" :disabled="item.disabled == null ? false : !item.disabled">{{item.label}}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    props: ["dialogObj"],
    data() {
      return {};
    },
    methods: {
      btnEvent(action) {
        this.$emit(action);
      },
      handleDialogClose() {
        this.$emit("handleDialogClose");
        this.dialogObj.isShow = false;
      },

    }
  }

</script>

<style lang="scss" scoped>
  /deep/ .el-dialog{
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/dialogs.vue